import '../assets/styles/component.css'

export default function SubTitle(){
    return(
        <div className="subtitle-container">
            <div className="subtitle-rectangle bg-advise-color"></div>
            <div className="subtitle-line bg-stone-400"></div>
        </div>
    )
}